import React from "react";
import "./Footerdata.css";

const Footerdata = () => {
    return (
        <footer className="footer">
            <div className="footer-container">

                {/* LEFT */}
                <div className="footer-left">
                    MAAMAAS
                </div>

                {/* CENTER */}
                <div className="footer-center">
                    © 2026 MAAMAAS. All rights reserved.
                </div>

                {/* RIGHT */}
                {/* <div className="footer-right">
                    <a href="#">Privacy</a>
                    <a href="#">Terms</a>
                    <a href="#">Support</a>
                </div> */}

            </div>
        </footer>
    );
};

export default Footerdata;